var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_124051",
    "data-name": "Group 124051",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#1b4a83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-account-box",
    "data-name": "Icon material-account-box",
    d: "M4.5,5.92v9.942a1.42,1.42,0,0,0,1.42,1.42h9.942a1.425,1.425,0,0,0,1.42-1.42V5.92a1.425,1.425,0,0,0-1.42-1.42H5.92A1.42,1.42,0,0,0,4.5,5.92Zm8.522,2.841a2.131,2.131,0,1,1-2.131-2.131A2.128,2.128,0,0,1,13.022,8.761ZM6.631,14.442c0-1.42,2.841-2.2,4.261-2.2s4.261.781,4.261,2.2v.71H6.631Z",
    transform: "translate(308.108 250.108)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.e47400938bf5c98dc61ed2a73fe0d41d.svg";
export { ForwardRef as ReactComponent };